import { useMemo } from 'react';
import { useAnalysisContext } from '../../analysis/context';
import { useDataSource } from '../data-source';
import type { MapTimelineProps } from './MapTimeline';
import { localIsoDate } from '../../lib/localDate';
import { useServerToday } from '../../analysis/useSliceDate';

/**
 * Ползунок даты, привязанный к контексту анализа (`as_of` в адресе).
 *
 * Возвращает `undefined`, если источник маршрута — фикстуры: срез прототипа
 * датой не управляется, и ползунок, который ничего не меняет, был бы обманом.
 * На каноне смена даты перечитывает все наборы экрана, которые читают
 * контекст анализа, — и слой карты, и таблицы рядом с ней.
 *
 * Шкала — с начала года текущей даты до «сегодня»; страница может передать
 * свои границы.
 */
export function useAsOfTimeline(range?: { from?: string; to?: string }): MapTimelineProps | undefined {
  const kind = useDataSource().current.kind;
  const { asOf, setAsOf } = useAnalysisContext();
  // Конец шкалы — «сегодня» сервера: позже него среза не бывает.
  const today = useServerToday() ?? localIsoDate();
  const to = range?.to ?? today;
  const from = range?.from ?? `${to.slice(0, 4)}-01-01`;
  return useMemo(
    () => (kind === 'api' ? { from, to, value: asOf, onChange: setAsOf, step: 'week' as const } : undefined),
    [kind, from, to, asOf, setAsOf],
  );
}
